/* eslint-disable react/no-danger */
import React, { useState } from 'react'
import { Reoverlay } from 'reoverlay'
import InquireModal from 'components/modals/inquireModal'

// parse out the extra text node and return if it exists
const CTAText = ({ descriptiveText }) => {
  if (!descriptiveText) return null
  return <div className="ctaText" dangerouslySetInnerHTML={{ __html: descriptiveText }} />
}

function CallToAction({ descriptiveText, children }) {
  const [isSent, setIsSent] = useState(false)

  const signMeUp = () => {
    Reoverlay.showModal(InquireModal, {
      isSent,
      modalSubmit: () => {
        setIsSent(true)
      },
      resetForm: () => {
        Reoverlay.hideModal()
        setIsSent(false)
      },
    })
  }
  return (
    <>
      <CTAText descriptiveText={descriptiveText} />
      <button type="button" className="btn btn-primary" onClick={signMeUp}>
        {children}
      </button>
    </>
  )
}

export default CallToAction
